import gql from 'graphql-tag';

export const BankListQuery = gql`
  query bankList {
    bankList {
      id
      kod
      swift
      banka
    }
  }
`;
